import { render, staticRenderFns } from "./NewsAndInformation.vue?vue&type=template&id=68661e92&scoped=true&"
import script from "./NewsAndInformation.vue?vue&type=script&lang=js&"
export * from "./NewsAndInformation.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndInformation.vue?vue&type=style&index=0&id=68661e92&scoped=true&lang=css&"
import style1 from "./NewsAndInformation.vue?vue&type=style&index=1&id=68661e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68661e92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardText,VCardTitle,VCol,VImg,VOverlay,VRow})
